export default __webpack_public_path__ + "static/media/five_icon24.d5fa79a8.png";